import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="notfound-page">
      <p className="notfound-eyebrow">404</p>
      <h1>Page not found</h1>
      <p>Sorry, the page you are looking for doesn&apos;t exist or has moved.</p>
      <Link to="/" className="btn">
        Back to Home
      </Link>
    </div>
  );
}
